import React from "react";
import PropTypes from "prop-types";

import { ReactComponent as SuccessIcon } from "../../../../assets/images/habitacional/tracking/sucess-status.svg";

import * as S from "./TrackingStatus.Style";

const StatusItem = ({ icon, title, description, isCompleted, currentStep }) => {
  return (
    <S.StatusContainer currentStep={currentStep} isCompleted={isCompleted}>
      <S.Content>
        {icon}
        <S.StatusTitle isCompleted={isCompleted}>
          {title}
          {isCompleted && <SuccessIcon />}
        </S.StatusTitle>
        <S.StatusDescrption>{description}</S.StatusDescrption>
      </S.Content>
    </S.StatusContainer>
  );
};

StatusItem.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string,
  description: PropTypes.string,
  isCompleted: PropTypes.bool,
  currentStep: PropTypes.bool,
};

StatusItem.defaultProps = {
  icon: null,
  title: "",
  description: "",
  isCompleted: false,
  currentStep: false,
};

export default StatusItem;
